__turbopack_context__.v({
  "modalContainer": "sharePreview-module__je5Ncq__modalContainer",
  "modalWrap": "sharePreview-module__je5Ncq__modalWrap",
  "previewChat": "sharePreview-module__je5Ncq__previewChat",
  "previewRoot": "sharePreview-module__je5Ncq__previewRoot",
});
